import { getSignedURL, uploadAudioFile } from "../../../Client/request";
import { S3_BASE_URL } from "../../../Client/apiURL";

export const processAudioUpload = async (recordedBlobFile) => {
  if (!recordedBlobFile) return null;
  
  for (let attempt = 0; attempt < 2; attempt += 1) {
    try {
      const signedUrlRes = await getSignedURL(30000);
      if (signedUrlRes && signedUrlRes.responseCode === 200) {
        const uploadSuccess = await uploadAudioFile(
          signedUrlRes.response,
          recordedBlobFile,
          120000
        );
        if (uploadSuccess) {
          return `${S3_BASE_URL}/${signedUrlRes.key}`;
        }
      }
    } catch (error) {
      console.error('Audio upload failed:', error);
    }
  }
  return null;
};
